import { render, staticRenderFns } from "./OrganismParkingAccess.vue?vue&type=template&id=067b029b&scoped=true&"
import script from "./OrganismParkingAccess.vue?vue&type=script&lang=js&"
export * from "./OrganismParkingAccess.vue?vue&type=script&lang=js&"
import style0 from "./OrganismParkingAccess.vue?vue&type=style&index=0&id=067b029b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b029b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomLottieAnimation: require('/app/components/atoms/common/AtomLottieAnimation.vue').default})
